<div *ngIf="employeeService.isEmployeeDeleted">
    <div class="msgs-wrapper">
        <div class="msgs">Trabajador eliminado</div>
    </div>
</div>

<div id="employee-view" class="page-layout blank" *ngIf="!employeeService.isEmployeeDeleted">
 
    <div class="content">

        <div  class="left">

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
                    <app-header></app-header>
                </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                *ngIf="employeeService.HasWarningCreationPermit && employeeService.EmployeeWarningText">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
                    <app-warning-panel></app-warning-panel>
                </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">

                <!-- Widget stat-count -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="25">
                    <app-trabajador></app-trabajador>
                    <app-bajas></app-bajas>
                    <app-documentos *ngIf="IsDocumentoVisible && !employeeService.isEmployeeLocked"></app-documentos>
                </div>
                <!-- / Widget stat-count -->

                <!-- Widget appointments -->
                <div *ngIf="employeeService.isShowPanel" class="widget" fxFlex="100" fxFlex.gt-sm="75">
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                        <div class="widget" fxFlex="100" fxFlex.gt-sm="40">
                            <app-baja></app-baja>
                        </div>
                        <div class="widget" fxFlex="100" fxFlex.gt-sm="60">
                            <app-tareas *ngIf="!employeeService.isEmployeeLocked"></app-tareas>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                        <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
                            <app-actuaciones></app-actuaciones>
                        </div>
                    </div>
                </div>
                <!-- / Widget appointments -->

            </div>

        </div>

    </div>

</div>